export default "__VITE_ASSET__0fceffb1__"